import { NOTIFICATION_TYPES } from "../getStockPageSectionFromNotificationType";

export const SUPPLY_DEMAND_NOTIFICATION_TYPES = [
  NOTIFICATION_TYPES.DEMAND_ZONE,
  NOTIFICATION_TYPES.TRANSACTION_STRATEGY_SUPPLY_DEMAND
];
